<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light" style="z-index: 16000">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col sm="3" md="2" xl="2" class="pt-1 pb-0">
          <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  hide-details
                  v-model="formatedDate"
                  label="Zeitraum"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                type="month"
                scrollable
                locale="de"
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="modal = false"
              >
                Abbrechen
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="setDate(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col sm="3" md="2" xl="2" class="pt-1 pb-0" style="align-content: center">
                      <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Rufbereitschaft</span>
        </v-col>
        <v-col class="pt-3 pb-0 text-right" >
          <b-button v-if="saveNeeded" variant="warning" class="btn-pill font-lg" style="color: white" @click="onCancel">
            Abbrechen
          </b-button>
          <b-button v-if="currentMitas.length !== 0" variant="success" class="btn-pill font-lg ml-2" style="color: white" @click="showSchedulerTable">
            Direktbearbeiten
          </b-button>
          <b-button v-if="currentMitas.length !== 0" variant="success" class="btn-pill font-lg ml-2" style="color: white" @click="showUseRaster">
            Rufbereitschaftsraster anwenden
          </b-button>
          <b-button variant="primary" class="btn-pill font-lg ml-2" style="color: white" v-on:click="onBack">
            &nbsp;Zurück
          </b-button>

        </v-col>
      </v-row>
      <v-row class="m-0">
        <v-col sm="3" md="2" xl="2">
          <v-select
              v-model="mita_select_value"
              :items="mita_select"
              filled
              hide-details
              label="Darstellungsart"
              @change="unselectMitas"
          ></v-select>
          <v-text-field v-if="mita_select_value === 'Mitarbeiter'" class="mt-1" prepend-inner-icon="mdi-magnify" hide-details single-line filled label="Suchen" v-model="search" @input="unselectMitas" clearable @click:clear="clearSearch"></v-text-field>
          <v-btn
              v-if="mita_select_value === 'Rufbereitschaftsgruppen'"
              block
              tile
              class="mt-1"
              color="success"
              v-on:click="onCreateRbGroup"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            Neue Gruppe
          </v-btn>
          <v-list v-if="mita_select_value === 'Mitarbeitergruppen'" style="max-height: 75vh; overflow-y: auto">
            <v-list-group
                v-for="(migr, j) in filteredMigrs"
                :key="j"
                @click="unselectMitas">
              <template v-slot:activator>
                <v-list-item-title v-text="migr"></v-list-item-title>
              </template>
              <v-list-item-group
                  v-model="currentMitas"
                  multiple>
                <v-list-item
                    v-for="(mita, i) in sortedItems(migr)"
                    :key="mita.id"
                    :value="mita.id"
                    @click.capture.stop="onMitaClicked(mita.id, migr, $event)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="mita.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
          </v-list>
          <v-list v-else-if="mita_select_value === 'Rufbereitschaftsgruppen'" style="max-height: 75vh; overflow-y: auto">
            <v-list-group
                v-for="(group, j) in filteredRbGroups"
                :key="j"
                @click="unselectMitas">
              <template v-slot:activator>
                <v-list-item-title v-text="group.value"></v-list-item-title>
              </template>
              <template v-slot:prependIcon>
                <v-icon
                    blue
                    @click="onEditRbGroup(group.id, $event)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <v-list-item-group
                  v-model="currentMitas"
                  multiple>
                <v-list-item
                    v-for="(mita, i) in sortedItemsGroups(group.id)"
                    :key="mita.id"
                    :value="mita.id"
                    @click.capture.stop="onMitaClicked(mita.id, '', $event, group.id)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="mita.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
          </v-list>
          <v-list v-else style="max-height: 70vh; overflow-y: auto">
            <v-list-item-group
                v-model="currentMitas"
                color="primary"
                multiple
            >
              <v-list-item
                  v-for="(mita, i) in filteredItems"
                  :key="mita.id"
                  :value="mita.id"
                  @click.capture.stop="onMitaClicked(mita.id, 'filteredItems', $event)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="mita.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col>
          <v-card
              style="width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;">
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="blue"
                :weekday-format="myDayFormat"
                :month-format="myMonthFormate"
                :event-ripple="false"
                :events="events"
                type="month"
                :weekdays="weekdayOrder"
                @change="onCalendarDateChange"
                @click:day="onDayClicked"
                @click:more="onMoreClicked"
                event-more-text="Mehr anzeigen"
            >
              <template v-slot:day-label="{date, day, present, month}">
                <v-row class="m-0" style="margin-top: -6px !important;">
                  <v-col md="9" class="p-1 text-left">
                    <v-chip
                        v-if="date in holidays"
                        class="soll-ist zero text-truncate"
                        label small
                    >
                      {{holidays[date]}}
                    </v-chip>
                  </v-col>
                  <v-col v-if="!present" md="3" class="p-1"><v-btn fab  x-small depressed>{{day}}</v-btn></v-col>
                  <v-col v-else md="3" class="p-1 text-left"><v-btn fab  x-small depressed color="#63c2de">{{day}}</v-btn></v-col>
                </v-row>
              </template>
              <template v-slot:event="{ event, timed, eventSummary }" >
                <div  :class="[event.id !== 'created' ? 'clickable' : '', 'v-event-draggable']">
                  <!--component :is="{ render: eventSummary }"></component-->
                  <div class="v-event-summary" style="color: white">{{event.name}}</div>
                </div>
              </template>
            </v-calendar>
          </v-card>
          <!--v-overlay
              absolute
              :value="currentMitas.length === 0"
              style="margin: 12px"
              opacity="0.1"
          >
            <v-row>
              <v-col>
              </v-col>
            </v-row>
          </v-overlay-->
        </v-col>
      </v-row>
      <v-dialog
          v-model="showRasterDialog"
          max-width="450px"
          persistent
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Rufbereitschaftsraster anwenden</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                >
                  <v-select
                      v-if="!rbs || rbs.length > 1"
                      style="margin-bottom: 14px"
                      v-model="selectedRb"
                      :items="rbs"
                      item-text="value"
                      item-value="web_server_id"
                      label="Rufbereitschaft auswählen"
                      hide-details="true"
                      no-data-text="Es wurde noch keine Rufbereitschaft definiert."
                  ></v-select>
                  <v-select
                      style="margin-bottom: 14px"
                      v-model="selectedRaster"
                      :return-object="true"
                      :items="rasters"
                      item-text="bezeichnung"
                      item-value="id"
                      label="Rufbereitschaftsraster auswählen"
                      hide-details="true"
                      no-data-text="Kein passendes Rufbereitschaftsraster gefunden."
                      @change="onRasterSelected"
                  ></v-select>
                  <!--v-select
                      v-model="selectedWeekDays"
                      :items="possibleWeekDays"
                      chips
                      label="Tage des Rasters auswählen (leer lassen für ganzes Raster)"
                      multiple
                  ></v-select-->
                  <v-dialog
                      ref="dialog_select_start"
                      v-model="rasterSelectModal"
                      :return-value.sync="rasterSelectModal"
                      persistent
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="formatedDateRasterStart"
                          label="Startdatum"
                          prepend-icon="mdi-calendar"
                          readonly
                          :disabled="selectedRaster === null"
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="rasterSelectDate"
                        :picker-date.sync="selectedMonthModal"
                        type="date"
                        scrollable
                        :allowed-dates="allowedDates"
                        locale="de"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="rasterSelectModal = false"
                      >
                        Abbrechen
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="setDateRaster(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <!--v-text-field
                      v-model="formatedDateRasterEnd"
                      label="Enddatum"
                      prepend-icon="mdi-calendar"
                      readonly
                      disabled
                      hint="Wird automatisch gesetzt"
                      persistent-hint
                  ></v-text-field-->

                  <v-select
                      v-if="rb_use_responsibilities.value === 'true'"
                      style="margin-top: 14px"
                      v-model="selectedPhase"
                      :items="phases"
                      item-text="value"
                      item-value="web_server_id"
                      label="Rufbereitschaftszuständigkeit auswählen"
                      hide-details="true"
                      no-data-text="Es wurde noch keine Rufbereitschaftszuständigkeit definiert."
                      ref="phase_select"
                  >
                    <template v-slot:append-item>
                      <v-divider class="mt-2"></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-text-field style="margin-top: 0"
                              label="Neu anlegen"
                              hint="Zum Beispiel: 'Gebiet Ost (spät)'"
                              append-outer-icon="mdi-content-save"
                              v-model="newPhase"
                                        @click:append-outer="onNewPhase"
                                        v-on:keyup.enter="onNewPhase"
                          ></v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                  <v-select
                      v-if="rb_use_callers.value === 'true'"
                      style="margin-top: 14px"
                      v-model="selectedCallers"
                      :items="possibleCallers"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      label="Rufer auswählen"
                      hint="Mitarbeiter die in diesem Zeitraum als Rufer fungieren."
                      persistent-hint
                  ></v-select>

                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelUseRaster"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitUseRaster"
                :disabled="selectedRaster === null || rasterEndDate === null || selectedRb === null"
            >
              Anwenden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showConflictDialog"
          max-width="450px"
          persistent
      >
        <v-card>
          <v-card-title>
            Es sind Konflikte aufgetreten
          </v-card-title>
          <v-card-subtitle class="mt-0">
            Bitte wählen Sie aus wie mit folgenden Konflikten umgegangen werden soll.
          </v-card-subtitle>
          <v-card-text>
            <v-container class="p-0">
              <v-row v-if="this.holidayConflicts.length !== 0">
                <v-col>
                  <span class="text-h6" style="font-weight: 400;color: black;">Überschneidungen mit Urlaub</span>
                  <v-card-subtitle class="mt-0 p-0">
                    Sie können die Rufbereitschaft entweder dennoch buchen oder die Rufbereitschaft an Urlaubstagen aussetzen.
                  </v-card-subtitle>
                  <v-radio-group
                      v-model="shouldApplyToHolidays"
                      column
                  >
                    <v-radio
                        label="Dennoch buchen"
                        value="true"
                    ></v-radio>
                    <v-radio
                        label="An Urlaubstagen aussetzen"
                        value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <hr v-if="this.holidayConflicts.length !== 0 && this.overwriteConflicts.length !== 0">
              <v-row v-if="this.overwriteConflicts.length !== 0">
                <v-col>
                  <span class="text-h6" style="font-weight: 400;color: black;">Überschneidende Rufbereitschaft</span>
                  <v-card-subtitle class="mt-0 p-0">
                    Sie können entweder die bestehenden Rufbereitschaftsabschnitte überschreiben oder die neuen Abschnitte, welche zu Überschneidungen führen, ignorieren.
                  </v-card-subtitle>
                  <v-radio-group
                      v-model="shouldOverwrite"
                      column
                  >
                    <v-radio
                        label="Bestehende überschreiben"
                        value="true"
                    ></v-radio>
                    <v-radio
                        label="Bestehende beibehalten"
                        value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelConflict"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitConflict"
                :disabled="(shouldApplyToHolidays === '' && holidayConflicts.length !== 0) || (shouldOverwrite === '' && overwriteConflicts.length !== 0)"
            >
              Absenden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showMore"
          max-width="450px"
          persistent
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Rufbereitschaft für {{moreDate}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="v-calendar-monthly v-calendar-weekly v-calendar theme--light v-calendar-events" role="grid" style="border: none;">
                <div role="row" class="v-calendar-weekly__week">
                  <div class="v-calendar-weekly__day-label" style="width: 100%;">
                    <div v-for="e in moreEvents" class="v-event v-event-start v-event-end white--text mt-1"
                         :style="{'height': '20px', 'width': '100%', 'margin-bottom': '1px', 'background-color': e.color, 'border-color': e.color}">
                      <div data-v-341adc5c="" class="clickable v-event-draggable">
                        <div data-v-341adc5c="" class="v-event-summary" style="color: white;">{{e.name}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelShowMore"
            >
              Zurück
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- free select multiple -->
      <v-dialog
          v-model="showModify"
          max-width="500px"
          persistent
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Rufbereitschaft: {{modifyDate}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-select
                      style="margin-bottom: 14px"
                      v-model="selectedRb"
                      :items="rbs"
                      item-text="value"
                      item-value="web_server_id"
                      label="Rufbereitschaft auswählen"
                      hide-details="true"
                      no-data-text="Es wurde noch keine Rufbereitschaft definiert."
                  ></v-select>
                  <v-select
                      style="margin-bottom: 14px"
                      v-model="selectedPhase"
                      :items="phases"
                      item-text="value"
                      item-value="web_server_id"
                      label="Rufbereitschaftszuständigkeit auswählen"
                      hide-details="true"
                      no-data-text="Es wurde noch keine Rufbereitschaftszuständigkeit definiert."
                      ref="phase_select"
                  >
                    <template v-slot:append-item>
                      <v-divider class="mt-2"></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-text-field style="margin-top: 0"
                                        label="Neu anlegen"
                                        hint="Zum Beispiel: 'Gebiet Ost (spät)'"
                                        append-outer-icon="mdi-content-save"
                                        v-model="newPhase"
                                        @click:append-outer="onNewPhase"
                                        v-on:keyup.enter="onNewPhase"
                          ></v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                  <v-select
                      style="margin-bottom: 14px"
                      v-model="selectedCallers"
                      :items="possibleCallers"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      label="Rufer auswählen"
                      hint="Mitarbeiter die in diesem Zeitraum als Rufer fungieren."
                      persistent-hint
                  ></v-select>
              <v-sheet outlined height="500">
                <v-calendar
                    style="padding-bottom: 25px; padding-top: 25px; border: none"
                    :value="modifyDateObject.date"
                    ref="calendar_daily"
                    color="primary"
                    type="day"
                    :event-ripple="false"
                    locale="de-DE"
                    interval-minutes="15"
                    :interval-count="24 * 4"
                    :hide-header="true"
                    :short-intervals="false"
                    :interval-format="formatInterval"
                    :interval-height="24"
                    :events="timeSelectionEvents"
                    :event-color="getEventColor"
                    @mousedown:event="startDragTimeline"
                    @mousedown:time="startTimeTimeLine"
                    @mousemove:time="mouseMoveTimeLine"
                    @mouseup:time="endDragTimeLine"
                    @mouseleave.native="cancelDragTimeLine"
                >
                  <template v-slot:event="{ event, timed, eventSummary }">
                    <div class="v-event-draggable">
                      <v-row>
                        <v-col md="9">
                          <component :is="{ render: eventSummary }"></component>
                        </v-col>
                        <v-col v-if="event.eventType === 'rb'" md="3">
                          <v-icon @click="onRbDelete(event)"
                                  style="float: right; margin-top: 3px; margin-right: 3px; cursor: pointer"
                                  color="white"
                          >
                            mdi-delete
                          </v-icon>

                        </v-col>
                      </v-row>
                    </div>
                    <div
                        v-if="event.eventType === 'rb'"
                        class="v-event-drag-bottom"
                        @mousedown.stop="extendBottomTimeLine(event)"
                    ></div>
                  </template>
                </v-calendar>
              </v-sheet>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                v-on:click.stop="onCancelModify"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                :disabled="!canSave"
                v-on:click.stop="onSaveModify"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showConflictModifyDialog"
          max-width="450px"
          persistent
      >
        <v-card>
          <v-card-title>
            Es sind Konflikte aufgetreten
          </v-card-title>
          <v-card-subtitle class="mt-0">
            Bitte wählen Sie aus wie mit folgenden Konflikten umgegangen werden soll.
          </v-card-subtitle>
          <v-card-text>
            <v-container class="p-0">
              <v-row v-if="this.holidayConflictsModify.length !== 0">
                <v-col>
                  <span class="text-h6" style="font-weight: 400;color: black;">Überschneidungen mit Urlaub</span>
                  <v-card-subtitle class="mt-0 p-0">
                    Sie können die Rufbereitschaft entweder dennoch buchen oder die Rufbereitschaft an Urlaubstagen aussetzen.
                  </v-card-subtitle>
                  <v-radio-group
                      v-model="shouldApplyToHolidaysModify"
                      column
                  >
                    <v-radio
                        label="Dennoch buchen"
                        value="true"
                    ></v-radio>
                    <v-radio
                        label="An Urlaubstagen aussetzen"
                        value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <hr v-if="this.holidayConflictsModify.length !== 0 && this.overwriteConflictsModify.length !== 0">
              <v-row v-if="this.overwriteConflictsModify.length !== 0">
                <v-col>
                  <span class="text-h6" style="font-weight: 400;color: black;">Überschneidende Rufbereitschaft</span>
                  <v-card-subtitle class="mt-0 p-0">
                    Sie können entweder die bestehenden Rufbereitschaftsabschnitte überschreiben oder die neuen Abschnitte, welche zu Überschneidungen führen, ignorieren.
                  </v-card-subtitle>
                  <v-radio-group
                      v-model="shouldOverwriteModify"
                      column
                  >
                    <v-radio
                        label="Bestehende überschreiben"
                        value="true"
                    ></v-radio>
                    <v-radio
                        label="Bestehende beibehalten"
                        value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelConflictModify"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitConflictModify"
                :disabled="(shouldApplyToHolidaysModify === '' && holidayConflictsModify.length !== 0) || (shouldOverwriteModify === '' && overwriteConflictsModify.length !== 0)"
            >
              Absenden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showRbGroup"
          max-width="450px"
          persistent
          scrollable
      >
        <v-card>
          <v-card-title v-if="isRbCreate">
            Neue Rufbereitschaftsgruppe
          </v-card-title>
          <v-card-title v-else>
            Gruppe:   {{selectedRbGroup.value}}
          </v-card-title>
          <v-card-text>
            <v-container class="p-0">
              <v-row v-if="isRbCreate">
                <v-col
                >
                  <v-text-field
                      label="Gruppenname"
                      counter
                      maxlength="50"
                      v-model="rbGroupName"
                      class="mb-2"
                  ></v-text-field>
                  <v-list style="overflow-y: auto; height: 350px">
                    <v-list-item-group
                        v-model="selectedRbGroupMitas"
                        color="primary"
                        multiple
                    >
                      <v-list-item
                          v-for="(mita, i) in filteredItems"
                          :key="mita.id"
                          :value="mita.id"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-text="mita.name"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col>
                  <v-list style="overflow-y: auto; height: 350px">
                    <v-list-item-group
                        v-model="selectedRbGroupMitas"
                        color="primary"
                        multiple
                    >
                      <v-list-item
                          v-for="(mita, i) in filteredItems"
                          :key="mita.id"
                          :value="mita.id"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-text="mita.name"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelRbGroup"
            >
              Abbrechen
            </v-btn>
            <v-btn
                v-if="!isRbCreate"
                color="red darken-1"
                text
                @click="onDeleteRbGroup"
            >
              Löschen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                :disabled="(isRbCreate && rbGroupName.trim() === '') || selectedRbGroupMitas.length === 0"
                @click="onSubmitRbGroup"
            >
              Speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showDeleteRbGroupConfirm"
          max-width="450px"
          persistent
      >
        <v-card>
          <v-card-title class="text-h5">
            Rufbereitschaftsgruppe löschen ?
          </v-card-title>
          <v-card-text>
            Soll die Rufbereitschaftsgruppe: <b>{{selectedRbGroup.value}}</b> gelöschen werden ?<br>Dies kann nicht rückgängig gemacht werden.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelDeleteRbGroup"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="red darken-1"
                text
                @click="onSubmitDeleteRbGroup"
            >
              Löschen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showErrorEditRbGroup"
          max-width="450px"
          persistent
      >
        <v-card>
          <v-card-title class="text-h5">
            Fehlende Berechtigung
          </v-card-title>
          <v-card-text>
            Die Rufbereitschaftsgruppe: <b>{{selectedRbGroup.value}}</b> umfasst Mitarbeiter, für die Sie keine Berechtigung besitzen.<br>Diese Gruppe kann dementsprechend nicht von Ihnen anpasst werden.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelRbGroup"
            >
              Abbrechen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <scheduler-table ref="schedulerTable" :start-date="detailStart" :end-date="detailEnd" :mitas="currentMitas" :raster="selectedRaster"></scheduler-table>
    </div>
  </v-main>
</template>

<script>
import _orderBy from "lodash/orderBy";
import {Cookie_Path, Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _throttle from "lodash/throttle";
import {getUid} from "@/shared/crypto";
import SchedulerTable from "@/views/rufbereitschaft/SchedulerTable.vue";

export default {
  name: "RbCalendar",
  data: () => ({
    mita_select: ['Mitarbeitergruppen', 'Rufbereitschaftsgruppen', 'Mitarbeiter'],
    mita_select_value: 'Mitarbeiter',
    focus: '',
    migrs: [],
    mitas: [],
    mitasFlat: [],
    activeMita:[],
    rb_groups: [],
    rbs: [],
    rb_group_map: {},
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "July", "August", "September", "Oktober", "November", "Dezember"],
    currentMonth: 0,
    currentYear: 0,
    startDate: null,
    endDate: null,

    overlay: true,
    currentMitas: [],

    azras: [],
    rasters: [],

    search: '',
    date: new Date().toISOString().substr(0, 7),
    modal: false,

    // user rb specific
    holidays: [],
    userRb: [],
    events: [],

    // raster select
    showRasterDialog: false,
    selectedRaster: null,
    selectedRb: null,
    rasterStartDate: null,
    rasterEndDate: null,
    rasterSelectDate: null,
    rasterSelectModal: false,
    selectedMonth: "",
    selectedMonthModal: "",
    selectedWeekDays: [],
    weekDaysSelect: [
      {name: "Sonntag", value: 0, index: 6},
      {name: "Montag", value: 1, index: 0},
      {name: "Dienstag", value: 2, index: 1},
      {name: "Mittwoch", value: 3, index: 2},
      {name: "Donnerstag", value: 4, index: 3},
      {name: "Freitag", value: 5, index: 4},
      {name: "Samstag", value: 6, index: 5},
    ],

    // confict data
    showConflictDialog: false,
    shouldApplyToHolidays: null,
    holidayConflicts: [],
    shouldOverwrite: null,
    overwriteConflicts: [],

    // confict data modify
    showConflictModifyDialog: false,
    shouldApplyToHolidaysModify: null,
    holidayConflictsModify: [],
    shouldOverwriteModify: null,
    overwriteConflictsModify: [],

    // controls
    saveNeeded: false,

    // more
    showMore: false,
    moreDate: "",
    moreDateObject: {},

    // free modify multiple
    showModify: false,
    modifyDate: "",
    modifyDateObject: {},
    timeSelectionEvents: [],
    // currently edited event
    createEventTimeLine: null,
    // start time of currently edited event
    createStartTimeLine: null,
    // end time of dragged event
    extendOriginalTimeLine: null,
    // dragging
    dragEventTimeline: null,
    dragStartTimeline: null,

    // rb groups
    showRbGroup: false,
    isRbCreate: false,
    selectedRbGroup: {},
    rbGroupName: "",
    selectedRbGroupMitas: [],

    showDeleteRbGroupConfirm: false,
    showErrorEditRbGroup: false,

    // rb phase
    phases: [],
    selectedPhase: null,
    newPhase: "",

    // callers
    selectedCallers: [],

    rb_use_responsibilities:       {value: "false"},
    rb_use_callers:       {value: "false"},

    detailStart: null,
    detailEnd: null,
  }),
  components: {
    SchedulerTable,
  },
  computed: {
    possibleWeekDays() {
      if (this.selectedRaster === null) {
        return null;
      }
      let cur = new Date(this.selectedRaster.start);
      let end = new Date(this.selectedRaster.end);
      let res = []
      while (res.length < 7 && cur.getTime() > end.getTime()) {
        res.push(this.weekDaysSelect[cur.getDay()]);
        cur.setDate(cur.getDate()+1);
      }
      res.sort((a, b) => {return a.index - b.index})
      console.log(res);
      return res;
    },
    filteredItems() {
      return _orderBy(this.mitasFlat.filter(item => {
        if(!this.search) return this.mitasFlat;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },
    filteredRbGroups() {
      return _orderBy(this.rb_groups, [val => val.value.toLowerCase()]);
    },
    filteredMigrs() {
      return _orderBy(this.migrs, [val => val.toLowerCase()]);
    },
    formatedDate() {
      let splits = this.date.split("-");
      return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
    },
    formatedDateRasterStart() {
      if (this.rasterStartDate) {
        return this.rasterStartDate.split("-").reverse().join(".");
      } else {
        return ""
      }
    },
    formatedDateRasterEnd() {
      if (this.rasterEndDate) {
        return this.rasterEndDate.split("-").reverse().join(".");
      } else {
        return ""
      }
    },
    moreEvents() {
      let moreEvents = [];
      for (let i = 0; i < this.events.length; i++) {
        let parsed = this.$refs.calendar.parseEvent(this.events[i]);
        if (parsed.start.date === this.moreDateObject.date) {
          moreEvents.push(this.events[i]);
        }
      }
      return moreEvents;
    },
    canSave() {
      if (this.selectedRb === null) {
        return false;
      }
      if (this.currentMitas.length === 1) {
        return true;
      }
      for (let i = 0; i < this.timeSelectionEvents.length; i++) {
        if (this.timeSelectionEvents[i].eventType === "rb") {
          return true;
        }
      }
      return false;
    },
    possibleCallers() {
      let pos = [];
      for (let i = 0; i < this.currentMitas.length; i++) {
        for (let j = 0; j < this.mitasFlat.length; j++) {
          if (this.currentMitas[i] === this.mitasFlat[j].id) {
            pos.push(this.mitasFlat[j]);
            break;
          }
        }
      }
      return _orderBy(pos, [val => val.name.toLowerCase()])
    }
  },
  mounted () {
    this.$refs.calendar.updateTimes()
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/rufbereitschaft/calendar'
    ).then(this.responseOkGet, this.responseError)
    if (this.$cookies.isKey("rb_calendar")) {
      this.mita_select_value = this.$cookies.get("rb_calendar");
    }
  },
  methods: {
    showSchedulerTable(mode) {
      if (mode !== 'raster') {
        this.detailStart = this.startDate.date;
        this.detailEnd = this.endDate.date;
        this.selectedRaster = null;
      }
      this.$nextTick(() => {
        this.$refs.schedulerTable.show();
      });
    },
    onNewPhase() {
      if (this.newPhase.trim() === "") {
        return
      }
      let p = {
        web_server_id: getUid(),
        amount: -1,
        value: this.newPhase,
      }
      this.phases.push(p);
      this.selectedPhase = p.web_server_id;
      this.newPhase = "";
      this.$refs.phase_select.$refs.menu.isActive = false;
    },
    onCreateRbGroup() {
      this.isRbCreate = true;
      this.showRbGroup = true;
    },
    onEditRbGroup(groupId, e) {
      e.stopPropagation();
      e.preventDefault();
      this.isRbCreate = false;
      for (let i = 0; i < this.rb_groups.length; i++) {
          if (this.rb_groups[i].id === groupId) {
            this.selectedRbGroup = this.rb_groups[i];
            break;
          }
      }
      if (this.selectedRbGroup.amount !== this.rb_group_map[this.selectedRbGroup.id].length) {
        this.showErrorEditRbGroup = true;
        return
      }
      let rbMitas = [];
      for (let i = 0; i < this.rb_group_map[this.selectedRbGroup.id].length; i++) {
        rbMitas.push(this.rb_group_map[this.selectedRbGroup.id][i].id);
      }
      this.selectedRbGroupMitas = rbMitas;
      this.showRbGroup = true;
    },
    onCancelRbGroup() {
      this.showErrorEditRbGroup = false;
      this.showRbGroup = false;
      this.isRbCreate = false;
      this.selectedRbGroup = {};
      this.rbGroupName = "";
      this.selectedRbGroupMitas = [];
    },
    onCancelDeleteRbGroup() {
      this.showDeleteRbGroupConfirm = false;
    },
    onDeleteRbGroup() {
      this.showDeleteRbGroupConfirm = true;
    },
    onSubmitDeleteRbGroup() {
      this.showDeleteRbGroupConfirm = false;
      let data = {
        group_id: this.selectedRbGroup.id,
        delete: true,
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/rb_groups', data
      ).then(this.responseOkDeleteRbGroup, this.responseError)
      this.onCancelRbGroup();
    },
    responseOkDeleteRbGroup(response) {
      this.hideLoader();
      if (response.status === 200) {
        let deletedGroupId = response.body.id;
        let index = -1;
        for (let i = 0; i < this.rb_groups.length; i++) {
          if (this.rb_groups[i].id === deletedGroupId) {
            index = i;
            break
          }
        }
        if (index !== -1) {
          this.rb_groups.splice(index, 1);
          delete this.rb_group_map[deletedGroupId];
          this.unselectMitas()
        }
      } else {
        window.location = Redirect_500;
      }
    },
    onSubmitRbGroup() {
      if (!this.isRbCreate) {
        let data = {
          group_id: this.selectedRbGroup.id,
          delete: false,
          mitas: this.selectedRbGroupMitas,
        }
        this.showLoader();
        this.$http.post(
            Server_URL_ZK + '/zk/rufbereitschaft/rb_groups', data
        ).then(this.responseOkChangeRbGroup, this.responseError)
      } else {
        let data = {
          group_name: this.rbGroupName,
          delete: false,
          mitas: this.selectedRbGroupMitas,
        }
        this.showLoader();
        this.$http.post(
            Server_URL_ZK + '/zk/rufbereitschaft/rb_groups', data
        ).then(this.responseOkCreateRbGroup, this.responseError)
      }
    },
    responseOkChangeRbGroup(response) {
      this.hideLoader();
      if (response.status === 200) {
        let groupUsers = [];
        let newUsers = response.body.group_users;
        for (let i = 0; i < newUsers.length; i++) {
          for (let j = 0; j < this.mitasFlat.length; j++) {
            if (newUsers[i].value === this.mitasFlat[j].id) {
              groupUsers.push(this.mitasFlat[j]);
              break
            }
          }
        }
        this.rb_group_map[this.selectedRbGroup.id] = groupUsers;
        this.unselectMitas();
        this.onCancelRbGroup();
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkCreateRbGroup(response) {
      this.hideLoader();
      if (response.status === 200) {
        let groupUsers = [];
        let newUsers = response.body.group_users;
        let newGroup = response.body.group;
        for (let i = 0; i < newUsers.length; i++) {
          for (let j = 0; j < this.mitasFlat.length; j++) {
            if (newUsers[i].value === this.mitasFlat[j].id) {
              groupUsers.push(this.mitasFlat[j]);
              break
            }
          }
        }
        this.rb_groups.push(newGroup)
        this.rb_group_map[newGroup.id] = groupUsers;
        this.unselectMitas();
        this.onCancelRbGroup();
      } else {
        window.location = Redirect_500;
      }
    },
    onRbDelete(event) {
      const i = this.timeSelectionEvents.indexOf(event)
      if (i !== -1) {
        this.timeSelectionEvents.splice(i, 1)
      }
      if (this.createStartTimeLine && this.createEventTimeLine.id === event.id) {
        this.cancelDragTimeLine();
      }
    },
    onDayClicked(d, event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.currentMitas.length === 0) {
        return;
      }
      this.modifyDate = d.date.split("-").reverse().join(".")
      this.modifyDateObject = d;
        this.timeSelectionEvents = [];
        // get all mitas and their azras to get the minimum work start and maximum work end time
        let azras = [];
        for (let i = 0; i < this.currentMitas.length; i++) {
          let cur = this.getCurrentMita(this.currentMitas[i]);
          let mitaAzra = cur.azra.replace(/\D/g,'');
          if (mitaAzra === "") {
            continue;
          }
          for (let j = 0; j < this.azras.length; j++) {
            if (this.azras[j].bis_id.padStart(6, '0') === mitaAzra.padStart(6, '0')) {
              azras.push(this.azras[j]);
            }
          }
        }
        if (this.holidays[d.date] !== undefined) {
          azras = [];
        }
        let workStart = "99:99";
        let workEnd = "00:00";
        let timeMap = ["time_sun", "time_mon", "time_tue", "time_wed", "time_thu", "time_fri", "time_sat"]
      console.log(azras)
        for (let i = 0; i < azras.length; i++) {
          console.log(azras[i])
          let time = azras[i][timeMap[this.modifyDateObject.weekday%7]];
          let s = time.split("-")[0]
          let e = time.split("-")[1]
          if (s !== "00:00" && s < workStart && time.split("-").length === 2) {
            workStart = s;
          }
          if (e !== "00:00" && e > workEnd && time.split("-").length === 2) {
            workEnd = e
          }
        }
        // when start == 99:99 and end == 00:00 then now azra, let them choose freely
        if (workStart !== "99:99" && workEnd !== "00:00") {
          let start = new Date(`${this.modifyDateObject.date}T${workStart}:00`)
          let end = new Date(`${this.modifyDateObject.date}T${workEnd}:00`)
          let name = "Arbeitszeit"
          let color = "#b2ea24"
          this.timeSelectionEvents.push({
            id: "AZRA",
            name: name,
            start: start,
            end: end,
            color: color,
            timed: true,
            eventType: "azra",
          })
        }
      if (this.currentMitas.length === 1) {
        // get all rbs for the given day
        for (let i = 0; i < this.events.length; i++) {
          let parsed = this.$refs.calendar.parseEvent(this.events[i]);
          if (parsed.start.date === this.modifyDateObject.date && this.events[i].eventType === "rb") {
            let start = new Date(this.events[i].start);
            let end = new Date(this.events[i].end);
            if (end.getMinutes() === 59 && end.getHours() === 23) {
              end.setDate(end.getDate() + 1);
              end.setHours(0, 0, 0)
            }
            let name = "Rufbereitschaft";
            this.timeSelectionEvents.push({
              id: this.events[i].id,
              name: name,
              start: start,
              end: end,
              color: this.events[i].color,
              timed: true,
              eventType: "rb",
            })
          }
        }
      }
      this.showModify = true;
      this.$nextTick(() => {
        setTimeout(() => this.$refs.calendar_daily.scrollToTime('07:00'), 150);
      });
    },
    onCancelModify() {
      this.showModify = false;
      this.cancelDragTimeLine();
      this.timeSelectionEvents = [];
      for (let i = this.phases.length - 1; i >= 0; i--) {
        if (this.phases[i].amount === -1) {
          this.phases.splice(i, 1);
        }
      }
      this.selectedPhase = null;
      this.selectedCallers = [];
    },
    onSaveModify() {
      let phase = null;
      if (this.selectedPhase !== null) {
        for (let i = 0; i < this.phases.length; i++) {
          if (this.selectedPhase === this.phases[i].web_server_id) {
            phase = this.phases[i];
            break;
          }
        }
      }
      let data = {
        date: this.modifyDateObject.date,
        from_date: this.startDate.date,
        to_date: this.endDate.date,
        mitas: this.currentMitas,
        init: this.currentMitas.length === 1 ? false : true,
        overwrite: this.currentMitas.length === 1 ? true : false,
        holiday: this.currentMitas.length === 1 ? true : false,
        rbs: [],
        rb_lohn: this.selectedRb,
        phase: phase,
        caller: this.selectedCallers,
      }
      for (let i = 0; i < this.timeSelectionEvents.length; i++) {
        let cur = this.timeSelectionEvents[i];
        if (cur.eventType === "rb") {
          let block = -1;
          if (this.currentMitas.length === 1) {
            // check if this is an existing entry
            for (let j = 0; j < this.userRb[0].rb.length; j++) {
              if (this.userRb[0].rb[j].id === cur.id) {
                block = this.userRb[0].rb[j].block;
                break
              }
            }
          }
          data.rbs.push({
            zeit_von: new Date(cur.start),
            zeit_bis: new Date(cur.end),
            block: block,
          })
        }
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/calendar/modify', data
      ).then(this.responseOkModify, this.responseErrorModify)
      //this.showModify = false;
    },
    formatInterval(a) {
      if (a.minute === 0) {
        return a.time;
      }
    },
    startDragTimeline({event, timed}) {
      if (event && timed && event.eventType !== "rb") {
        return
      }
      if (event && timed) {
        this.dragEventTimeline = event;
        this.dragTime = null;
        this.extendOriginalTimeLine = null;
      }
    },
    startTimeTimeLine (tms) {
      const mouse = this.roundTime(this.toTime(tms));
      let realTime = this.toTime(tms);
      if (this.dragEventTimeline && this.dragTime === null) {
        const start = this.dragEventTimeline.start;
        this.dragTime = realTime - start;
        return;
      }
      for (let i = 0; i < this.timeSelectionEvents.length; i++) {
        let blocked = this.timeSelectionEvents[i];
        if ((realTime < blocked.end)  &&  (realTime > blocked.start)) {
          return;
        }
      }

      this.createStartTimeLine = this.roundTime(mouse)
      this.createEventTimeLine = {
        id: getUid(),
        name: `Rufbereitschaft`,
        color: "#ea5324",
        start: this.createStartTimeLine,
        end: this.createStartTimeLine,
        timed: true,
        eventType: "rb",
      };
      this.timeSelectionEvents.push(this.createEventTimeLine)
    },
    extendBottomTimeLine (event) {
      this.createEventTimeLine = event
      this.createStartTimeLine = event.start
      this.extendOriginalTimeLine = event.end
    },
    mouseMoveTimeLine (tms) {
      const mouse = this.toTime(tms)
      if (this.dragEventTimeline && this.dragTime !== null) {
        const start = this.dragEventTimeline.start
        const end = this.dragEventTimeline.end
        const duration = end - start
        const newStartTime = mouse - this.dragTime
        const newStart = this.roundTime(newStartTime)
        const newEnd = newStart + duration;
        if (this.formatDate(newStart).split("T")[0] !== this.modifyDateObject.date) {
          return;
        } else if (this.formatDate(newEnd).split("T")[0] !== this.modifyDateObject.date &&
            ((new Date(newEnd)).getMinutes() !== 0 || (new Date(newEnd)).getHours() !== 0)) {
          return;
        }
        let isBlocked = false;
        for (let i = 0; i < this.timeSelectionEvents.length; i++) {
          let e = this.timeSelectionEvents[i];
          if (e.id !== this.dragEventTimeline.id && ((newStart < e.end)  &&  (newEnd > e.start))) {
            isBlocked = true;
            break
          }
        }
        if (isBlocked) {
          return;
        }
        this.dragEventTimeline.start = newStart
        this.dragEventTimeline.end = newEnd
      } else if (this.createEventTimeLine && this.createStartTimeLine !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStartTimeLine)
        const max = Math.max(mouseRounded, this.createStartTimeLine)
        for (let i = 0; i < this.timeSelectionEvents.length; i++) {
          let blocked = this.timeSelectionEvents[i];
          if (this.createEventTimeLine.id !== blocked.id && (min < blocked.end)  &&  (max > blocked.start)) {
            return;
          }
        }
        this.createEventTimeLine.start = min
        this.createEventTimeLine.end = max
      }
    },
    endDragTimeLine () {
      if (this.createEventTimeLine !== null && this.createEventTimeLine.start === this.createEventTimeLine.end) {
        const i = this.timeSelectionEvents.indexOf(this.createEventTimeLine)
        if (i !== -1) {
          this.timeSelectionEvents.splice(i, 1)
        }
      }
      this.createEventTimeLine = null
      this.createStartTimeLine = null
      this.extendOriginalTimeLine = null
      this.dragTime = null;
      this.dragEventTimeline = null;
    },
    cancelDragTimeLine () {
      this.createEventTimeLine = null
      this.createStartTimeLine = null
      this.extendOriginalTimeLine = null
      this.dragTime = null;
      this.dragEventTimeline = null;
    },
    roundTime (time, down = true) {
      const roundTo = 15 // minutes
      const roundDownTime = roundTo * 60 * 1000

      return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
    onMoreClicked(d, event) {
      event.preventDefault();
      event.stopPropagation();
      this.moreDate = d.date.split("-").reverse().join(".")
      this.moreDateObject = d;
      this.showMore = true;
    },
    onCancelShowMore() {
      this.showMore = false;
    },
    onCalendarDateChange(event) {
      this.currentMonth = this.$refs.calendar.parsedValue.month;
      this.currentYear = this.$refs.calendar.parsedValue.year;
      this.selectedMonth = this.currentYear.toString() + "-" + this.currentMonth.toString().padStart(2, "0");
      this.startDate = this.$refs.calendar.getStartOfWeek(event.start);
      this.endDate = this.$refs.calendar.getEndOfWeek(event.end);
      this.changeMitas();
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    sortedItems(migr) {
      return _orderBy(this.mitas[migr], 'name');
    },
    sortedItemsGroups(group_id) {
      return _orderBy(this.rb_group_map[group_id], 'name');
    },
    clearSearch () {
      this.search="";
      this.unselectMitas();
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        for (let i = 0; i < response.body.migrs.length; i++) {
          this.activeMita.push(null);
        }
        this.migrs = response.body.migrs;
        this.mitas = response.body.mita;
        for (let migr in this.mitas) {
          for (let i = 0; i < this.mitas[migr].length; i++) {
            this.mitas[migr][i].name = this.getMitaNameForGischl(this.mitas[migr][i]);
          }
        }
        for (let i = 0; i < response.body.mita_flat.length; i++) {
          let mita = response.body.mita_flat[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
        }
        this.rb_groups = response.body.rb_groups;
        this.rb_group_map = response.body.rb_group_map;
        for (let id in this.rb_group_map) {
          for (let i = 0; i < this.rb_group_map[id].length; i++) {
            this.rb_group_map[id][i].name = this.getMitaNameForGischl(this.rb_group_map[id][i]);
          }
        }
        this.azras = response.body.azras;
        this.rasters = response.body.rasters;
        this.rbs = response.body.rbs;
        if (this.rbs.length === 1) {
          this.selectedRb = this.rbs[0].web_server_id;
        }
        if (this.rasters && this.rasters.length === 1) {
          this.selectedRaster = this.rasters[0];
        }
        this.phases = response.body.phases;
        if (this.phases === null || this.phases === undefined) {
          this.phases = [];
        }
        this.rb_use_responsibilities = response.body.rb_use_responsibilities;
        this.rb_use_callers = response.body.rb_use_callers;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkGetMitas(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.holidays = response.body.all_holiday;
        this.userRb = response.body.user_rb;
        this.calculateEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    calculateEvents() {
      let events = [];
      // rb color
      let rbColor = "#ea5324"
      let holColor = "#2463ea"
      if (this.userRb.length > 1) {
        for (let i = 0; i < this.userRb.length; i++) {
            let cur = this.userRb[i];
            let mita = {name: ""};
          for (let j = 0; j < this.mitasFlat.length; j++) {
              if (this.mitasFlat[j].id === cur.id) {
                mita = this.mitasFlat[j];
                break
              }
          }
          for (let j = 0; j < cur.holidays.length; j++) {
            events.push({
              id: cur.holidays[j] + cur.id,
              name: "U " + mita.name,
              start: new Date(`${cur.holidays[j]}T00:00:00`),
              end: new Date(`${cur.holidays[j]}T00:00:00`),
              color: holColor,
              timed: false,
              eventType: "hol",
            })
          }
        }
        for (let i = 0; i < this.userRb.length; i++) {
          let cur = this.userRb[i];
          let mita = {name: ""};
          for (let j = 0; j < this.mitasFlat.length; j++) {
            if (this.mitasFlat[j].id === cur.id) {
              mita = this.mitasFlat[j];
              break
            }
          }
          for (let j = 0; j < cur.rb.length; j++) {
            let start = new Date(cur.rb[j].zeit_von)
            let end = new Date(cur.rb[j].zeit_bis)
            let endHours = end.getHours();
            let endMinutes = end.getMinutes();
            if (end.getDay() !== start.getDay()) {
              end.setDate(end.getDate() -1);
              end.setHours(23, 59, 0)
              endHours = 24;
              endMinutes = 0;
            }
            let name = start.getHours().toString().padStart(2, "0") + ":" +
                start.getMinutes().toString().padStart(2, "0")+ " - " +
                endHours.toString().padStart(2, "0") + ":" +
                endMinutes.toString().padStart(2, "0");
            events.push({
              id: cur.rb[j].id,
              name: "RB "+name + " " + mita.name,
              start: start,
              end: end,
              color: rbColor,
              timed: false,
              eventType: "rb",
            })
          }
        }
      } else if (this.userRb.length === 1) {
        let cur = this.userRb[0];
        for (let i = 0; i < cur.holidays.length; i++) {
          events.push({
            id: cur.holidays[i] + cur.id,
            name: "Urlaub",
            start: new Date(`${cur.holidays[i]}T00:00:00`),
            end: new Date(`${cur.holidays[i]}T00:00:00`),
            color: holColor,
            timed: false,
            eventType: "hol",
          })
        }
        for (let i = 0; i < cur.rb.length; i++) {
          let start = new Date(cur.rb[i].zeit_von)
          let end = new Date(cur.rb[i].zeit_bis)
          let endHours = end.getHours();
          let endMinutes = end.getMinutes();
          if (end.getDay() !== start.getDay()) {
            end.setDate(end.getDate() -1);
            end.setHours(23, 59, 0)
            endHours = 24;
            endMinutes = 0;
          }
          let name = start.getHours().toString().padStart(2, "0") + ":" +
              start.getMinutes().toString().padStart(2, "0")+ " - " +
              endHours.toString().padStart(2, "0") + ":" +
              endMinutes.toString().padStart(2, "0");
          events.push({
            id: cur.rb[i].id,
            name: "RB "+name,
            start: start,
            end: end,
            color: rbColor,
            timed: false,
            eventType: "rb",
          })
        }
      }
      this.events = events;
    },
    responseError(response) {
      console.log(response);
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setDate(date) {
      this.$refs.dialog.save(date);
      this.focus = date+"-01";
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    changeMitas() {
      if (this.currentMitas.length === 0) {
        // undo data
        this.holidays = [];
            this.userRb = [];
            this.events = [];
      } else {
        // perform request
        this.showLoader();
        let data = {
          from: this.startDate.date,
          to: this.endDate.date,
          mitas: this.currentMitas,
        }
        this.$http.post(
            Server_URL_ZK + '/zk/rufbereitschaft/calendar', data
        ).then(this.responseOkGetMitas, this.responseError)
      }
    },
    onBack() {
      window.history.back();
    },
    onSave() {

    },
    onCancel() {

    },
    showUseRaster() {
      this.showRasterDialog = true;
      this.selectedRaster = null;
      if (this.rasters && this.rasters.length === 1) {
        this.selectedRaster = this.rasters[0];
      }
      this.rasterSelectDate = null;
      this.rasterStartDate = null;
      this.rasterEndDate = null;
      this.selectedMonthModal = this.selectedMonth;
    },
    onCancelUseRaster() {
      this.showRasterDialog = false;
      this.selectedRaster = null;
      this.rasterSelectDate = null;
      this.rasterStartDate = null;
      this.rasterEndDate = null;
      for (let i = this.phases.length - 1; i >= 0; i--) {
        if (this.phases[i].amount === -1) {
          this.phases.splice(i, 1);
        }
      }
      this.selectedPhase = null;
      this.selectedCallers = [];
    },
    allowedDates(val) {
      if (this.selectedRaster) {
        return new Date(val).getDay() === new Date(this.selectedRaster.start).getDay()
      }
    },
    onRasterSelected() {
      this.rasterStartDate = null;
      this.rasterEndDate = null;
      this.rasterSelectDate = null;
    },
    setDateRaster(date) {
      this.$refs.dialog_select_start.save(date);
      this.rasterStartDate = this.rasterSelectDate;
      console.log(this.selectedRaster);
      let rasterStart = new Date(this.selectedRaster.start.split('T')[0])
      let rasterEnd = new Date(this.selectedRaster.ende.split('T')[0])
      const diffTime = Math.abs(rasterEnd - rasterStart);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      let rasterEndDate = new Date(this.rasterStartDate);
      rasterEndDate.setDate(rasterEndDate.getDate() + diffDays);
      this.rasterEndDate = `${rasterEndDate.getFullYear().toString()}-${(rasterEndDate.getMonth()+1).toString().padStart(2, '0')}-${rasterEndDate.getDate().toString().padStart(2, '0')}`;
    },
    onSubmitUseRaster() {
      //this.showRasterDialog = false;
      let phase = null;
      if (this.selectedPhase !== null) {
        for (let i = 0; i < this.phases.length; i++) {
          if (this.selectedPhase === this.phases[i].web_server_id) {
            phase = this.phases[i];
            break;
          }
        }
      }

      let data = {
        raster_id: this.selectedRaster.id,
        from: this.rasterStartDate,
        from_date: this.startDate.date,
        to_date: this.endDate.date,
        mitas: this.currentMitas,
        init: true,
        rb_lohn: this.selectedRb,
        phase: phase,
        caller: this.selectedCallers,
      }
      console.log(data)

      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/calendar/raster', data
      ).then(this.responseOkApplyRaster, this.responseErrorApplyRaster)
    },
    responseOkApplyRaster(response) {
      this.hideLoader();
      this.onCancelUseRaster()
      if (response.status === 200) {
        let phase = response.body.phase;
        if (this.selectedPhase !== null) {
          for (let i = 0; i < this.phases.length; i++) {
            if (this.selectedPhase === this.phases[i].web_server_id) {
              this.phases.splice(i, 1);
              this.phases.push(phase);
              break;
            }
          }
        }
        // clear all phases with amount = -1
        for (let i = this.phases.length - 1; i >= 0; i--) {
          if (this.phases[i].amount === -1) {
            this.phases.splice(i, 1);
          }
        }
        this.selectedPhase = null;
        this.selectedCallers = [];
        this.holidays = response.body.all_holiday;
        this.userRb = response.body.user_rb;
        this.calculateEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkModify(response) {
      this.hideLoader();
      this.onCancelModify()
      if (response.status === 200) {
        // if the current selected phase is new replace it with the new one
        let phase = response.body.phase;
        if (this.selectedPhase !== null) {
          for (let i = 0; i < this.phases.length; i++) {
            if (this.selectedPhase === this.phases[i].web_server_id) {
              this.phases.splice(i, 1);
              this.phases.push(phase);
              break;
            }
          }
        }
        for (let i = this.phases.length - 1; i >= 0; i--) {
          if (this.phases[i].amount === -1) {
            this.phases.splice(i, 1);
          }
        }
        this.selectedPhase = null;
        this.selectedCallers = [];
        this.holidays = response.body.all_holiday;
        this.userRb = response.body.user_rb;
        this.calculateEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    responseErrorApplyRaster(response) {
      this.hideLoader();
      if (response.status === 409) {
        let intersects = response.body.intersects;
        // if the current selected phase is new replace it with the new one
        let phase = response.body.phase;
        if (this.selectedPhase !== null) {
          for (let i = 0; i < this.phases.length; i++) {
            if (this.selectedPhase === this.phases[i].web_server_id) {
              this.phases.splice(i, 1);
              this.phases.push(phase);
              this.selectedPhase = phase.web_server_id;
              break;
            }
          }
        }
        this.holidayConflicts = [];
        this.overwriteConflicts = [];
        for (let i = 0; i < intersects.length; i++) {
          if (intersects[i].holiday.length !== 0) {
            this.holidayConflicts.push(intersects[i]);
          }
          if (intersects[i].old_schicht.length !== 0) {
            this.overwriteConflicts.push(intersects[i]);
          }
        }
        this.showConflictDialog = true;
      } else if (response.status === 401) {
        console.log(response);
        window.location = Redirect_Login;
      } else {
        console.log(response);
        window.location = Redirect_500;
      }
    },
    responseErrorModify(response) {
      this.hideLoader();
      if (response.status === 409) {
        let intersects = response.body.intersects;
        let phase = response.body.phase;
        if (this.selectedPhase !== null) {
          for (let i = 0; i < this.phases.length; i++) {
            if (this.selectedPhase === this.phases[i].web_server_id) {
              this.phases.splice(i, 1);
              this.phases.push(phase);
              this.selectedPhase = phase.web_server_id;
              break;
            }
          }
        }
        this.holidayConflictsModify = [];
        this.overwriteConflictsModify = [];
        for (let i = 0; i < intersects.length; i++) {
          if (intersects[i].holiday.length !== 0) {
            this.holidayConflictsModify.push(intersects[i]);
          }
          if (intersects[i].old_schicht.length !== 0) {
            this.overwriteConflictsModify.push(intersects[i]);
          }
        }
        this.showConflictModifyDialog = true;
      } else if (response.status === 401) {
        console.log(response);
        window.location = Redirect_Login;
      } else {
        console.log(response);
        window.location = Redirect_500;
      }
    },
    unselectMitas() {
      this.currentMitas = [];
      this.changeMitas();
      this.setCookie("rb_calendar", this.mita_select_value, -1, null, Cookie_Path, true)
    },
    onMitaClicked(mitaId, mitaGroup, e, groupId) {
      if (e.ctrlKey) {
        let index = this.currentMitas.indexOf(mitaId);
        if (index === -1) {
          this.currentMitas.push(mitaId);
        } else {
          this.currentMitas.splice(index, 1);
        }
      } else if (e.shiftKey) {
        if (this.currentMitas.length === 0) {
          this.currentMitas = [mitaId];
        } else {
          let sorted
          if (groupId !== undefined) {
            sorted = this.sortedItemsGroups(groupId)
          } else if (mitaGroup === "filteredItems") {
            sorted = this.filteredItems;
          } else {
            sorted = this.sortedItems(mitaGroup);
          }
          let indexA, indexB
          let lastMitaId = this.currentMitas[this.currentMitas.length-1];
          for (let i = 0; i < sorted.length; i++) {
            if (sorted[i].id === mitaId) {
              indexA = i;
            } else if (sorted[i].id === lastMitaId) {
              indexB = i;
            }
          }
          let indexFrom = Math.min(indexA, indexB);
          let indexTo = Math.max(indexA, indexB);
          for (let i = indexFrom; i < indexTo+1; i++) {
            let cur = sorted[i].id;
            if (this.currentMitas.indexOf(cur) === -1) {
              this.currentMitas.push(cur)
            }
          }
        }
      } else {
        let index = this.currentMitas.indexOf(mitaId);
        if (index === -1) {
          this.currentMitas = [mitaId];
        } else {
          this.currentMitas = [];
        }
      }
      this.changeMitas()
    },
    // helpers
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.dragEvent
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event === this.createEvent
              ? `rgba(${r}, ${g}, ${b}, 0.7)`
              : event.color
    },
    formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    // conflict handling
    onCancelConflict() {
      this.showConflictDialog = false;
      this.shouldApplyToHolidays = null;
      this.holidayConflicts = [];
      this.shouldOverwrite = null;
      this.overwriteConflicts = [];
      for (let i = this.phases.length - 1; i >= 0; i--) {
        if (this.phases[i].amount === -1) {
          this.phases.splice(i, 1);
        }
      }
      this.selectedPhase = null;
      this.selectedCallers = [];
    },
    onSubmitConflict() {
      let phase = null;
      if (this.selectedPhase !== null) {
        for (let i = 0; i < this.phases.length; i++) {
          if (this.selectedPhase === this.phases[i].web_server_id) {
            phase = this.phases[i];
            break;
          }
        }
      }
      let data = {
        raster_id: this.selectedRaster.id,
        from: this.rasterStartDate,
        from_date: this.startDate.date,
        to_date: this.endDate.date,
        mitas: this.currentMitas,
        init: false,
        overwrite: this.shouldOverwrite === 'true',
        holiday: this.shouldApplyToHolidays === 'true',
        rb_lohn: this.selectedRb,
        phase: phase,
        caller: this.selectedCallers,
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/calendar/raster', data
      ).then(this.responseOkApplyRaster, this.responseError)
      this.onCancelConflict();
    },
    // conflict handling
    onCancelConflictModify() {
      this.showConflictModifyDialog = false;
      this.shouldOverwriteModify = null;
      this.overwriteConflictsModify = [];
      this.shouldApplyToHolidaysModify = null;
      this.holidayConflictsModify = [];
      for (let i = this.phases.length - 1; i >= 0; i--) {
        if (this.phases[i].amount === -1) {
          this.phases.splice(i, 1);
        }
      }
      this.selectedPhase = null;
      this.selectedCallers = [];
    },
    onSubmitConflictModify() {
      let phase = null;
      if (this.selectedPhase !== null) {
        for (let i = 0; i < this.phases.length; i++) {
          if (this.selectedPhase === this.phases[i].web_server_id) {
            phase = this.phases[i];
            break;
          }
        }
      }
      let data = {
        date: this.modifyDateObject.date,
        from_date: this.startDate.date,
        to_date: this.endDate.date,
        mitas: this.currentMitas,
        init: false,
        overwrite: this.shouldOverwriteModify === 'true',
        holiday: this.shouldApplyToHolidaysModify === 'true',
        rbs: [],
        rb_lohn: this.selectedRb,
        phase: phase,
        caller: this.selectedCallers,
      }
      for (let i = 0; i < this.timeSelectionEvents.length; i++) {
        let cur = this.timeSelectionEvents[i];
        if (cur.eventType === "rb") {
          let block = -1;
          if (this.currentMitas.length === 1) {
            // check if this is an existing entry
            for (let j = 0; j < this.userRb[0].rb.length; j++) {
              if (this.userRb[0].rb[j].id === cur.id) {
                block = this.userRb[0].rb[j].block;
                break
              }
            }
          }
          data.rbs.push({
            zeit_von: new Date(cur.start),
            zeit_bis: new Date(cur.end),
            block: block,
          })
        }
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/calendar/modify', data
      ).then(this.responseOkModify, this.responseError)
      this.onCancelConflictModify();
    },
    isElectron() {
      let userAgent = navigator.userAgent.toLowerCase();
      return userAgent.indexOf(' electron/') > -1;
    },
    setCookie(keyName, value, expireTimes, path, domain, secure) {
      this.$cookies.set(keyName, value, expireTimes, path, domain, secure);
      if (this.isElectron()) {
        window.top.postMessage(
            {
              typ: 'cookie',
              keyName: keyName,
              value: value,
              expireTimes: expireTimes,
              path: path,
              domain: domain,
              secure: secure
            }, "*");
      }
    },
  }
}
</script>

<style lang="scss">

.v-calendar .v-event {
  pointer-events: none;
}
.clickable {
  pointer-events: auto !important;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.zero {
  background-color: rgb(240, 230, 140) !important;
  border-color: rgb(240, 230, 140) !important;
}

.soll-ist.neg {
  background-color: rgb(255, 69, 0)!important;
  border-color: rgb(255, 69, 0)!important;
  color: white;
}

.soll-ist.pos {
  background-color: rgb(1, 109, 3)!important;
  border-color: rgb(1, 109, 3)!important;
  color: white;
}
.v-list-group__header__prepend-icon {
  margin-right: 8px !important;
}

</style>

<style scoped lang="scss">

.v-list-item-group .v-list-item--active{
  background-color: #63c2de;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

.theme--light::v-deep.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: 0px;
}

.theme--light::v-deep.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
  color: #000000 !important;
}

.v-chip::v-deep .v-chip__content {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: inline-block;
  text-align: center;
  padding-top: 2px;
}

.v-calendar::v-deep.v-calendar-events .v-calendar-weekly__day {
  margin-right: 0px;
}

.v-list-group__header__prepend-icon::v-deep {
  margin-right: 8px !important;
}

</style>
